// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1Wbch","row":"Settings_row__37a0t","paper":"Settings_paper__BNz4s","entry":"Settings_entry__1BcKO","footer":"Settings_footer__3Glez"};